export default __webpack_public_path__ + "static/media/klipartz.f819e8f3.png";